export const chartTypeCode = {
    LEIDA: '1',
    ZHUZHUANG: '2',
    ZHEXIAN: '3'
}

export const chartTypes = [
    { label: '雷达图', value: chartTypeCode.LEIDA },
    { label: '柱状图', value: chartTypeCode.ZHUZHUANG },
    { label: '折线图', value: chartTypeCode.ZHEXIAN },
]
export const chartTypeArr = ['雷达图','柱状图','折线图']